import { useMutation } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';

interface AdditionalTips {
  Icon: string;
  Text: string;
}

interface CreateSuggestionParams {
  AdditionalTips: AdditionalTips[];
  GoalId: string;
  clientId: number;
  fpId: string;
  DebtType?: number;
}

const createSuggestion = (suggestion: CreateSuggestionParams): Promise<string> =>
  authFetch(`/Consumer/UpdatePlanActionSteps/SaveAdditionalTips`, {
    method: 'POST',
    ...httpBodyOptions(suggestion, true),
  });

export const useCreateSuggestionMutation = () => {
  return useMutation(createSuggestion);
};
